import React from "react";

export default function SingleUserTestimonial(props) {

  const confirmDeletingContact = () => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if(confirmation === true){
      props.deleteHandler(props.contactId);
    } else {
      return;
    }
  }


  return (
    <div className={`single-user-testimonial main-card-cover ${props.userQueryType ? "testimonial-query-padding" : "testimonial-padding"}`}>
      {/* Query Type Tag Start */}
      {props.userQueryType ? (
        <span className={`custom-badge ${(props.userQueryType == "Question") ? "question-badge" : "cancel-badge"}`}>{props.userQueryType}</span>
      ) : (
        ""
      )}
      {/* Query Type Tag End */}

      {/* User Image and Name Start */}
      <div className="accountDetails d-flex justify-content-start align-items-center">
        {/* Image */}
        <img
          src={props.userImg ? props.userImg : "/images/unknownUser.jpg"}
          alt="testimonial-user-profile"
          className="testimonial-user-profile-pic"
        />
        {/* Details */}
        <div className="details">
          <p className="p-0 m-0 name fw-medium text-capitalize">
            {props.userName}
          </p>
          <p className="p-0 m-0 role">{props.userEmail}</p>
        </div>
      </div>
      {/* User Image and Name End */}

      {/* Other Details Start */}
      {props.bookingId ? (
        <p className="query-details">
          <span className="details-title">Booking Id:&nbsp;&nbsp;</span>
          <span>{props.bookingId}</span>
        </p>
      ) : (
        ""
      )}
      {/* Other Details End */}

      {/* Testimonial/Reason Text Start */}
      <div
        className="testimonial-text"
        style={{ marginTop: props.bookingId ? "8px" : "19px" }}
      >
        <p className="p-0 m-0">{props.testimonialText}</p>
      </div>
      {/* Testimonial/Reason Text End */}

       {/* Update and Delete Button */}
       <div className="update-delete-btns">
          <button className="del-btn btn" onClick={confirmDeletingContact}>
            <i className="fa-solid fa-trash"></i>
          </button>
        </div>

    </div>
  );
}
